import styled from "styled-components/macro";
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdCheckCircle,
  MdImage,
  MdMenu,
  MdPauseCircleFilled,
  MdPlayCircleFilled,
  MdStar,
  MdStarBorder,
} from "react-icons/md";
import React, { useEffect, useRef, useState } from "react";
import "../styles/Ordercomplete.css";
import Topnav from "../components/Topnav";
import { useNavigate, useParams } from "react-router";
import Footer from "../components/Footer";
import { isEmpty } from "../functions/isEmpty";
import { formatEuroCents } from "../functions/formatEuroCents";

export default function Ordercomplete({
  products,
  cart,
  setCart,
  reviews,
  isMobile,
  language,
  setLanguage,
  texts,
}) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [paymentIntentId, setPaymentIntentId] = useState(null);

  useEffect(() => {
    // URL Parameter auslesen
    const params = new URLSearchParams(window.location.search);
    const redirectStatus = params.get("redirect_status");

    if (redirectStatus === "failed") {
      // Wenn fehlgeschlagen, nicht Cart löschen, zurück zum Warenkorb
      navigate("/cart");
      return;
    }

    // Erfolgreich: Cart löschen
    localStorage.setItem("starthomeCart", "[]");
    setCart([]);
  }, [navigate, setCart]);

  useEffect(() => {
    // URL Parameter auslesen
    const params = new URLSearchParams(window.location.search);
    const id = params.get("payment_intent");
    setPaymentIntentId(id);
  }, []);

  useEffect(() => {
    // bestaetigungsmail senden
    // im php gucken ob mail sent flag gesetzt
  }, []);

  return (
    <div className="ordercomplete">
      <Topnav
        cart={cart}
        language={language}
        setLanguage={setLanguage}
        isMobile={isMobile}
      />
      <div className="ordercomplete_section">
        <div className="home_banner">
          {" "}
          {language == "Deutsch" ? texts.de.banner : texts.en.banner}{" "}
        </div>
        {isEmpty(paymentIntentId) ? (
          <div className="">Lädt ...</div>
        ) : (
          <div className="ordercomplete_section_wrapper">
            <div className="ordercomplete_section_icon">
              <CheckIcon />
            </div>
            <div className="ordercomplete_section_headline">
              Vielen Dank für deine Bestellung
            </div>
            <div className="ordercomplete_section_subheadline">
              Sobald deine Bestellung versandt wurde, benachrichtigen wir dich
              per Email.
            </div>
            {/*
            <div className="ordercomplete_section_ordersummary">
              <div className="ordercomplete_section_ordersummary_title">
                Bestellzusammenfassung
              </div>
             
              savedCart.map((item, index) => (
                <div className="ordercomplete_section_ordersummary_element">
                  <div className="ordercomplete_section_ordersummary_element_left"></div>
                  <div className="ordercomplete_section_ordersummary_element_middle"></div>
                  <div className="ordercomplete_section_ordersummary_element_right"></div>
                </div>
              ))
                
            </div>
                          */}

            <div
              className="ordercomplete_section_backtohome"
              onClick={() => navigate("/")}>
              Zur Startseite
            </div>
          </div>
        )}
      </div>
      <Footer texts={texts} language={language} />
    </div>
  );
}
const PlayIcon = styled(MdPlayCircleFilled)`
  font-size: 90px;
  color: #ffffff;
  margin-left: -8px;
  margin-top: -12px;
`;

const PauseIcon = styled(MdPauseCircleFilled)`
  font-size: 90px;
  color: #ffffff;
  margin-left: -8px;
  margin-top: -12px;
`;

const ArrowBackIcon = styled(MdArrowBackIosNew)`
  font-size: 20px;
  color: rgb(0, 119, 155);
`;

const CheckIcon = styled(MdCheckCircle)`
  font-size: 80px;
  color: rgb(0, 119, 155);
`;

const StarIcon = styled(MdStar)`
  font-size: 16px;
  color: #008793;
  margin-bottom: -3px;
`;

const StarIconLarge = styled(MdStar)`
  font-size: 36px;
  color: #008793;
  margin-bottom: -5px;
`;
